import { useMutation } from "@tanstack/react-query";
import { toast } from "@/components/core/toaster";
import apiClient from "@/api-client";
import { logger } from "@/lib/default-logger";

export interface SendEmailVerificationParams {
  email: string;
}

export interface ConfirmEmailVerificationParams {
  token: string;
}

export function useSendEmailVerification() {
  return useMutation({
    mutationFn: async (): Promise<void> => {
      const response = await apiClient.post("/email-verification/send-confirmation");
      return response.data;
    },
    onSuccess: () => {
      toast.success("Verification email sent successfully");
    },
    onError: (error: any) => {
      logger.error(error);
      const errorMessage = error?.response?.data?.message;
      toast.error(Array.isArray(errorMessage) ? errorMessage[0] : errorMessage || "Failed to send verification email");
    },
  });
}

export function useConfirmEmailVerification() {
  return useMutation({
    mutationFn: async (params: ConfirmEmailVerificationParams): Promise<void> => {
      const response = await apiClient.post("/email-verification/confirm-email", {
        token: params.token,
      });
      return response.data;
    },
    onSuccess: () => {
      toast.success("Email verified successfully");
    },
    onError: (error: any) => {
      logger.error(error);
      const errorMessage = error?.response?.data?.message;
      toast.error(Array.isArray(errorMessage) ? errorMessage[0] : errorMessage || "Failed to verify email");
    },
  });
}
